import React from 'react';
import IsHeMineIcon from "../Assets/ishemine-icon.png"

const Icon = () => {
  return (
    <img src={IsHeMineIcon} alt="Icon" className="h-20" />
  );
};

export default Icon;